export default "__VITE_ASSET__CMn$hRRx__"